import { AccountsClient } from "./accountsClient";

export const accountsClientStub: AccountsClient = {
  validateUsername: async () => {
    return {};
  },
  registerUser: async () => {
    return { status: "ok", message: null };
  },
  almostThere: async () => {
    return { returnUrl: "some-return-url-homie" };
  },
};
